import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { candidateBriefQueryKeys } from './queryKeys';
import type { CandidateExperienceApi, CandidatePathParams } from './types';

const candidateExperienceQueryOptions = (params: CandidatePathParams) => ({
  queryKey: candidateBriefQueryKeys.experience(params),
  queryFn: async () => {
    const { data } = await fetchClient.GET(
      '/jobs/{jobId}/candidates/{candidateId}/experience',
      { params: { path: params } },
    );

    return data as CandidateExperienceApi[];
  },
});

export function useCandidateExperienceQuery(params: CandidatePathParams) {
  return useQuery(candidateExperienceQueryOptions(params));
}

export function useCandidateExperienceSuspenseQuery(
  params: CandidatePathParams,
) {
  return useSuspenseQuery(candidateExperienceQueryOptions(params));
}
